<template>
  <div class="w-root">
    <div class="w-views">
      <div class="secondary-menu who-marked-me-favorite-users">

        <div class="secondary-menu-header">
          <i class="back" @click="goTo('/profile/settings')"></i>
          <div class="title">{{ trans('who_marked_me_favorite') }}</div>
        </div>

        <div class="secondary-menu-body">
          <ProfileWhoMarkedMeFavoriteUsersForm></ProfileWhoMarkedMeFavoriteUsersForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileWhoMarkedMeFavoriteUsersForm from "@profile/views/widgets/form/ProfileWhoMarkedMeFavoriteUsersForm.vue";

export default {
  name: "ProfileWhoMarkedMeFavoriteUsers",
  mixins: [require('@general/lib/mixin').default],
  components: {
    ProfileWhoMarkedMeFavoriteUsersForm
  }
}
</script>

<style scoped>

</style>